var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusConcluido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "status-concluido",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.869,
    height: 17,
    viewBox: "0 0 17.869 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1555",
    "data-name": "Caminho 1555",
    d: "M17.869,20.937l-2.023-2.246.317-3.007-2.958-.626L11.7,12.437,8.935,13.671,6.173,12.437,4.664,15.058l-2.958.626.317,3.007L0,20.937l2.023,2.246L1.706,26.19l2.958.626,1.509,2.621L8.935,28.2,11.7,29.437l1.509-2.621,2.958-.626-.317-3.007ZM8.935,27.055,6.609,28.094l-1.27-2.207L2.848,25.36l.267-2.531-1.7-1.891,1.7-1.891-.267-2.531,2.491-.527,1.27-2.207,2.325,1.039L11.26,13.78l1.27,2.207,2.492.527-.267,2.531,1.7,1.891-1.7,1.891.267,2.531-2.492.527-1.27,2.207Z",
    transform: "translate(0 -12.437)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1556",
    "data-name": "Caminho 1556",
    d: "M152.166,179.725l-3.746,4.2-2.332-2.332-.741.741,3.116,3.116,4.485-5.025Z",
    transform: "translate(-140.268 -173.879)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusConcluido);
export default __webpack_public_path__ + "static/media/status-concluido.42eb5f9b1cc677e199ef87a5b5ad084d.svg";
export { ForwardRef as ReactComponent };